import { render, staticRenderFns } from "./SelectionCreate.vue?vue&type=template&id=b2f47e86&scoped=true&"
import script from "./SelectionCreate.vue?vue&type=script&lang=js&"
export * from "./SelectionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f47e86",
  null
  
)

export default component.exports